// extracted by mini-css-extract-plugin
export var description = "index-module--description--Fqdeb";
export var partner = "index-module--partner--LtEEB";